<template>
  <v-container>
    <v-row>
      <v-col>
        <span class="d-flex flex-row align-center">
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span class="d-flex flex-row flex-wrap align-center">
            <h1>{{plural}}</h1>
            <v-btn class="ml-2" color="info" small fab @click="showCreateMenu"><v-icon>mdi-plus</v-icon></v-btn>
            <v-btn class="ml-8" color="info" @click="()=>{this.$router.push('/assets')}">Assets</v-btn>
            <v-btn class="ml-2" color="info" @click="()=>{this.$router.push('/alterations')}">Alterations</v-btn>
          </span>
        </span>
        <v-data-table
            :headers="headers"
            :items="allData"
            :options.sync="options"
            :server-items-length="pagination.dataCount"
            :loading="pagination.loading"
            :items-per-page="15"
            :footer-props="{
              itemsPerPageOptions: pagination.pageSizeOptions
            }"
            @click:row="rowClick"
        >
          <template v-slot:top>
            <v-text-field
                v-model="itemQuerySearch"
                label="Search..."
                class="mx-4"
                @change="searchItems"
            ></v-text-field>
          </template>
          <template v-slot:item.customer="{ item }">
            <span>{{ item.Customer?item.Customer.firstName+' '+item.Customer.lastName:'ERROR' }}</span>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="4" v-if="showSelected && selectedRow">
        <v-card outlined>
          <v-card-title>
            <span>{{singular}} #{{selectedRow.id}} Details</span>
          </v-card-title>
          <v-card-text>
            <span class="d-flex flex-column">
              <span>
                <span><b>Customer: </b>{{selectedRow.Customer?selectedRow.Customer.firstName+' '+selectedRow.Customer.lastName:'ERROR'}}</span>
                <br>
                <span v-if="selectedRow.Customer" class="d-flex flex-column">
                  <span v-if="selectedRow.Customer.phone"><b>Phone:</b>{{selectedRow.Customer.phone}}</span>
                  <span v-if="selectedRow.Customer.email"><b>Email:</b>{{selectedRow.Customer.email}}</span>
                </span>
              </span>
              <span>
                <span><b>Item: </b>{{selectedRow.Asset?selectedRow.Asset.styleNo:'ERROR'}}</span>
                <span v-if="selectedRow.Asset" class="ml-3">
                  <span>(</span>
                  <span><b>Asset ID:</b>{{selectedRow.Asset.id}}</span>
                  <span>)</span>
                </span>
              </span>
              <span><b>Colour: </b>{{selectedRow.colour}}</span>
            </span>
            <span>
              <h3 class="mt-5">Appointments Associated</h3>
              <v-data-table :items="selectedRowData.appointments" :headers="selectedRowData.tertiaryHeaders" :items-per-page="10" class="elevation-1" @click:row="appointmentClick" :loading="selectedRowData.loader">
                <template v-slot:item.scheduledFor="{ item }">
                  <span>{{ helpers.customFormatDate(item.scheduledFor) }}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip :color="helpers.getAppointmentStatusColor(item.status)">{{helpers.parseAppointmentStatus(item.status)}}</v-chip>
                </template>
                <template v-slot:item.outcome="{ item }">
                  <span>{{ parseOutcome(item.outcome) }}</span>
                </template>
              </v-data-table>
            </span>
            <span>
              <h3 class="mt-5">Jobs Associated</h3>
              <v-data-table :items="selectedRowData.jobs" :headers="selectedRowData.headers" :items-per-page="10" class="elevation-1" @click:row="jobClick" :loading="selectedRowData.loader">
                <template v-slot:item.dateOut="{ item }">
                  <span>{{ helpers.momentDateFormat(item.dateOut) }}</span>
                </template>
                <template v-slot:item.dateIn="{ item }">
                  <span>{{ helpers.momentDateFormat(item.dateIn) }}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <span>{{ helpers.parseJobStatus(item.status) }}</span>
                </template>
              </v-data-table>
            </span>
            <span>
              <h3 class="mt-5">Current Alterations</h3>
              <v-data-table :items="selectedRowData.alterations" :headers="selectedRowData.secondaryHeaders" item-key="key" :items-per-page="10" class="elevation-1"/>
            </span>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="closeMenu" color="error">Close</v-btn>
            <v-btn @click="deleteItem" color="warning">Delete</v-btn>
<!--            <v-btn @click="viewRow" color="success">View</v-btn>-->
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="4" v-if="showAddNew">
        <v-card outlined>
          <v-card-title>
            <span>Add New {{singular}}</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="validCreate">
              <span class="d-flex flex-row">
                <v-autocomplete
                    :items="customers"
                    :item-text="x => x.fullName + (x.phone?' | '+x.phone:'') + (x.email?' | '+x.email:'')"
                    item-value="id"
                    label="Customer"
                    outlined
                    clearable
                    :rules="rules.required"
                    v-model="formData.customerId"
                />
                <v-btn @click="showCreateCustomerDialog" class="mt-2 ml-2" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
              </span>
              <span class="d-flex flex-row">
                <v-autocomplete outlined label="Asset" :items="assets" item-text="styleNo" item-value="id" clearable :rules="rules.required" v-model="formData.assetId"/>
                <v-btn @click="showCreateAssetDialog" class="mt-2 ml-2" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
              </span>
              <v-text-field outlined label="Colour" v-model="formData.colour"/>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="closeMenu" color="error">Close</v-btn>
            <v-btn @click="create" color="success" :disabled="!validCreate">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog scrollable v-model="createCustomerDialog" max-width="600">
      <v-card>
        <v-card-title>
          Create Customer
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validCreateCustomer">
            <v-text-field
                label="First Name"
                outlined
                :rules="rules.required"
                v-model="newCustomer.firstName"
                @input="existingData=null"
            />
            <v-text-field
                label="Last Name"
                outlined
                :rules="rules.required"
                v-model="newCustomer.lastName"
                @input="existingData=null"
            />
            <v-text-field
                label="Phone"
                outlined
                :rules="rules.required"
                v-model="newCustomer.phone"
                @input="existingData=null"
            />
            <v-text-field
                label="Email"
                outlined
                v-model="newCustomer.email"
                @input="existingData=null"
            />
            <span>
              <h3>Address</h3>
              <v-text-field
                  label="Address Line 1"
                  outlined
                  v-model="newCustomer.address.line1"
                  @input="existingData=null"
              />
              <v-text-field
                  label="Address Line 2"
                  outlined
                  v-model="newCustomer.address.line2"
                  @input="existingData=null"
              />
              <v-text-field
                  label="City"
                  outlined
                  v-model="newCustomer.address.city"
                  @input="existingData=null"
              />
              <v-text-field
                  label="Notes"
                  outlined
                  v-model="newCustomer.notes"
                  @input="existingData=null"
              />
            </span>
          </v-form>
          <div v-if="existingData">
            <p class="red--text">A Customer with this phone number already exists. Are you sure you want to create another?</p>
            <h3>Or choose the existing Customer</h3>
            <v-btn color="info" @click="existingCustomerSelected">{{existingData.firstName}} {{existingData.lastName}}</v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateCustomer">
            Cancel
          </v-btn>
          <v-btn color="success" v-if="!existingData" :disabled="!validCreateCustomer" @click="createCustomer" :loading="customerLoading">Create</v-btn>
          <v-btn v-else color="success" :disabled="!validCreateCustomer" @click="confirmCreateCustomer" :loading="customerLoading">Create New</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="createAssetDialog" max-width="600">
      <v-card>
        <v-card-title>
          Create Asset
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validCreateAsset">
            <v-text-field
                label="Style No."
                outlined
                :rules="rules.required"
                v-model="newAsset.styleNo"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateAsset">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!validCreateAsset" @click="createAsset" :loading="assetLoading">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </v-container>
</template>
<script>
import axios from 'axios';
import helpers from "../../plugins/helpers";
import {mapGetters} from "vuex";
export default {
  data () {
    return {
      helpers: helpers,

      isEditable: false,

      snackObj: {
        color: '',
        text: ''
      },

      rules: {
        required: [v => !!v || 'This field is required.'],
      },
      validCreate: false,
      validCreateCustomer: false,
      validCreateAsset: false,

      itemQuerySearch: '',
      pagination: {
        loading: false,
        dataCount: 0,
        pageSizeOptions: [5, 10, 15, 30, -1]
      },
      options: {
        search: "",
        sortBy: ['id'],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 15
      },
      updatingRoute: false,
      init: false,
      manualRoute: false,

      loader: false,
      headers: [
        { text: 'ID', align: 'start', sortable: true, value: 'id' },
        { text: 'Customer', sortable: true, value: 'customer' },
        { text: 'Style No', sortable: true, value: 'Asset.styleNo' },
        { text: 'Colour', value: 'colour' },
        { text: '# of Jobs', value: 'numJobs' }
      ],
      allData: [],
      formData: {},

      selectedRow: null,
      selectedRowData: {
        alterations: [],
        jobs: [],
        appointments: [],
        loader: false,
        headers: [
          { text: 'Job #', align: 'start', sortable: true, value: 'id' },
          { text: 'Date Out', sortable: true, value: 'dateOut' },
          { text: 'Date In', sortable: true, value: 'dateIn' },
          { text: 'Status', sortable: true, value: 'status' },
        ],
        secondaryHeaders: [
          { text: 'Job', align: 'start', sortable: true, value: 'jobId' },
          { text: 'Name', value: 'name' },
          { text: 'Price', sortable: true, value: 'price' }
        ],
        tertiaryHeaders: [
          { text: 'App. #', align: 'start', sortable: true, value: 'id' },
          { text: 'App. Date', value: 'scheduledFor' },
          { text: 'Status', sortable: true, value: 'status' },
          { text: 'Outcome', sortable: true, value: 'outcome' }
        ],
      },
      showAddNew: false,
      showSelected: false,

      outcomes: [],

      assets: [],
      createAssetDialog: false,
      newAsset: {},
      assetLoading: false,

      customers: [],
      createCustomerDialog: false,
      newCustomer: {address: {}},
      customerLoading: false,

      existingData: null,

      pluralLower: "items",
      plural: "Items",
      singularLower: "item",
      singular: "Item"
    }
  },
  async created() {
    try {
      //used for pagination
      let oldQuery = this.getURLQuery();
      this.options.page = oldQuery.page || 1;
      this.options.itemsPerPage = oldQuery.limit || 15
      this.options.sortBy = [oldQuery.sort || "createdAt"]
      this.options.sortDesc = [oldQuery.order || false]
      this.options.search = oldQuery.search || ""
      this.itemQuerySearch = this.options.search;
      //used for pagination end
    } catch (error) {
      console.error(error)
      this.snack(error.msg || error, "error");
    }
  },
  async mounted(){

    this.init = true;

    let res = await axios.get(`${this.getEndpoint}/api/customers`)
    if(res.data.error) throw res.data.error;
    this.customers = res.data.data;

    res = await axios.get(`${this.getEndpoint}/api/assets`)
    if(res.data.error) throw res.data.error;
    this.assets = res.data.data;

    res = await axios.get(`${this.getEndpoint}/api/appointmentoutcomes`)
    if(res.data.error) throw res.data.error;
    this.outcomes = res.data.data;

    this.pagination.pageSizeOptions = this.getGlobalValue("paginationPageLimitsGeneral")?.split(",").map(x => parseInt(x)) || this.pagination.pageSizeOptions;
    await this.getAllData();
    this.init = false;
  },
  watch: {
    options: {
      async handler () {
        if(this.init) return;
        await this.getAllData();
      },
      deep: true,
    },
    $route: {
      handler: async function (current) {
        //used for pagination
        if (this.updatingRoute || this.manualRoute) return;
        let oldQuery = this.getURLQuery(current.query);
        this.options.page = oldQuery.page || 1;
        this.options.itemsPerPage = oldQuery.limit || 15
        this.options.sortBy = [oldQuery.sort || "id"]
        this.options.sortDesc = [oldQuery.order || false]
        this.options.search = oldQuery.search || ""
        //used for pagination end include full watcher
        await this.getAllData();
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters(['getEndpoint', 'getGlobalValue'])
  },
  methods: {
    searchItems(){
      this.options.search = this.itemQuerySearch;
    },
    parseOutcome(id){
      return this.outcomes.find(x => x.id===id)?.name||"Unknown";
    },
    getURLQuery(custom=null){
      let oldQuery = custom? {...custom}: {...this.$route.query};
      if(oldQuery.limit) oldQuery.limit = parseInt(oldQuery.limit);
      if(oldQuery.page) oldQuery.page = parseInt(oldQuery.page);
      if(oldQuery.order) oldQuery.order = oldQuery.order==='true';
      if(oldQuery.selected) oldQuery.selected = parseInt(oldQuery.selected);
      if(oldQuery.create) oldQuery.create = oldQuery.create==='true';
      return oldQuery;
    },
    async changeSelectedRow(){
      try {
        if(this.manualRoute) return;
        let id = this.$route.query.selected
        if(!id){
          this.showSelected = false
          this.selectedRow = null
          return;
        }

        let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${id}`)
        if(res.data.error) throw res.data.error;
        this.selectedRow = res.data.data

        res = await axios.get(`${this.getEndpoint}/api/jobs/byItemWithAppointments/${id}`)
        if(res.data.error) throw res.data.error;
        this.selectedRowData.jobs = res.data.data

        this.selectedRowData.appointments = this.selectedRowData.jobs.filter(x => x.Appointment).map(x => x.Appointment);

        let alterations = [];
        this.selectedRowData.jobs.forEach(job => {
          alterations = alterations.concat(job.itemAlterations.map(x => {
            return {...x, jobId: job.id}
          }))
        });

        this.selectedRowData.alterations = alterations;
        this.selectedRowData.alterations.forEach(alt => {
          alt.key=`${alt.id}-${alt.jobId}`
        })

        this.showAddNew = false;
        this.showSelected = true;

        this.updatingRoute = true;
        if(!(this.$route.query.selected && this.$route.query.selected==id)){
          await this.$router.replace({path: `/${this.pluralLower}`, query: {...this.$route.query, selected: id}})
        }
        this.updatingRoute = false;
      } catch (error) {
        console.log(error)
      }
    },
    async rowClick(row){
      try{
        window.scrollTo(0, 0);
        this.pagination.loading = true

        this.selectedRow = row;

        let res = await axios.get(`${this.getEndpoint}/api/jobs/byItemWithAppointments/${row.id}`)
        if(res.data.error) throw res.data.error;
        this.selectedRowData.jobs = res.data.data

        this.selectedRowData.appointments = this.selectedRowData.jobs.filter(x => x.Appointment).map(x => x.Appointment);

        let alterations = [];
        this.selectedRowData.jobs.forEach(job => {
          alterations = alterations.concat(job.itemAlterations.map(x => {
            return {...x, jobId: job.id}
          }))
        });

        this.selectedRowData.alterations = alterations;
        this.selectedRowData.alterations.forEach(alt => {
          alt.key=`${alt.id}-${alt.jobId}`
        })

        this.showAddNew = false;
        this.showSelected = true;

        delete this.$route.query.create;

        this.manualRoute = true;
        if(!(this.$route.query.selected && this.$route.query.selected==row.id)){
          await this.$router.replace({path: `/${this.pluralLower}`, query: {...this.$route.query, selected: row.id}})
        }
        this.manualRoute = false;
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.pagination.loading = false
      }
    },
    async viewRow(){
      await this.$router.push(`/${this.pluralLower}/view/${this.selectedRow.id}`)
    },
    async jobClick(row){
      await this.$router.push(`/jobs?selected=${row.id}`)
    },
    async appointmentClick(row){
      await this.$router.push(`/appointments/view/${row.id}`)
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
    async closeMenu(){
      this.showSelected = false;
      this.showAddNew = false;
      if(this.$route.query.selected){
        await this.$router.push({path: `/${this.pluralLower}`, query: null})
      }
    },
    async showCreateMenu(){
      if(!(this.$route.query.create)){
        delete this.$route.query.selected;
        await this.$router.push({path: `/${this.pluralLower}`, query: {...this.$route.query, create: "true"}})
      }

      this.formData = {};

      this.showSelected = false;
      this.showAddNew = true;
    },
    async create(){
      try {
        let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.formData)
        if(res.data.error) throw res.data.error;

        this.snack(`${this.singular} Created 🎉`);

        await this.getAllData();
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    },
    async getAllData(){
      try {
        //used for pagination
        this.pagination.loading = true;
        let paginationData = {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sort: (this.options.sortBy.length>0)?this.options.sortBy[0]:"id",
          order: this.options.sortDesc[0],
          search: this.options.search
        }

        let uriFields = Object.keys(paginationData).map(x => {
          return x + "=" + (paginationData[x]!==undefined?encodeURIComponent(paginationData[x]):'')
        }).join("&");
        //used for pagination end

        let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/tableDataPaginated?${uriFields}`)
        if(res.data.error) throw res.data.error;
        this.allData = res.data.data

        if(this.$route.query.selected) paginationData.selected = parseInt(this.$route.query.selected);
        if(this.$route.query.create) paginationData.create = this.$route.query.create==='true';

        if(this.$route.query && this.$route.query.create){
          await this.showCreateMenu();
          if(this.$route.query.customer){
            this.formData.customerId = this.customers.find(x => x.id===parseInt(this.$route.query.customer));
          }
        }

        //used for pagination
        this.pagination.dataCount = res.data.total
        let shouldUpdate = false;
        let oldQuery = this.getURLQuery();
        let newQuery = {...paginationData};

        if(Object.keys(newQuery).length!==Object.keys(oldQuery).length) shouldUpdate = true;
        if(!shouldUpdate){
          for(let key of Object.keys(newQuery)){
            if(shouldUpdate) break;

            if(Array.isArray(newQuery[key])){
              if(newQuery[key].length!==oldQuery[key].length){
                console.log("b", shouldUpdate)
                shouldUpdate = true;
                break;
              }
              for(let i=0;i<newQuery[key].length-1;i++){
                if(newQuery[key][i]!==oldQuery[key][i]){
                  console.log("c", newQuery[key][i], oldQuery[key][i])
                  shouldUpdate = true;
                  break;
                }
              }
            }
            else if(newQuery[key]!==oldQuery[key]){
              console.log("d", newQuery[key], oldQuery[key])
              shouldUpdate = true;
            }
          }
        }

        if(shouldUpdate){
          this.updatingRoute = true;
          if(this.init){
            if(this.$route.path===`/${this.pluralLower}`) await this.$router.replace({path: `/${this.pluralLower}`, query: {...this.$route.query, ...newQuery}});
          }
          else{
            if(this.$route.path===`/${this.pluralLower}`) await this.$router.push({path: `/${this.pluralLower}`, query: {...this.$route.query, ...newQuery}});
          }
          this.updatingRoute = false;
        }
        //used for pagination end

        await this.changeSelectedRow();

      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.pagination.loading = false;
      }
    },
    showCreateAssetDialog(){
      this.createAssetDialog = true;
    },
    closeCreateAsset(){
      this.createAssetDialog = false;
      this.newAsset = {};
      this.assetLoading = false;
    },
    async createAsset(){
      try{
        this.assetLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/assets`, this.newAsset)
        if(res.data.error) throw res.data.error;

        this.formData.assetId = res.data.data.data.id;

        if(res.data.data.created){
          this.snack(`${this.singular} Created 🎉`);

          res = await axios.get(`${this.getEndpoint}/api/assets`)
          if(res.data.error) throw res.data.error;
          this.assets = res.data.data;
        }
        else{
          this.snack(`${this.singular} already exists. Adding to form...`);
        }

        this.closeCreateAsset();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.assetLoading = false;
      }
    },
    showCreateCustomerDialog(){
      this.createCustomerDialog = true;
    },
    existingCustomerSelected(){
      this.formData.customerId = this.existingData.id;
      this.closeCreateCustomer();
    },
    closeCreateCustomer(){
      this.createCustomerDialog = false;
      this.newCustomer = {address: {}};
      this.existingData = null;
      this.customerLoading = false;
    },
    async createCustomer(){
      try{
        this.customerLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/customers`, this.newCustomer)
        if(res.data.error) throw res.data.error;

        let newC = res.data.data;

        if(newC.existing){
          this.existingData = newC;
          this.snack("Customer with this phone number already exists.")
          return;
        }

        res = await axios.get(`${this.getEndpoint}/api/customers`)
        if(res.data.error) throw res.data.error;
        this.customers = res.data.data;

        this.formData.customerId = newC;
        this.snack("Customer Created!", "success")
        this.closeCreateCustomer();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.customerLoading = false;
      }
    },
    async confirmCreateCustomer(){
      try{
        this.customerLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/customers/force`, this.newCustomer)
        if(res.data.error) throw res.data.error;

        let newC = res.data.data;

        res = await axios.get(`${this.getEndpoint}/api/customers`)
        if(res.data.error) throw res.data.error;
        this.customers = res.data.data;

        this.formData.customerId = newC;
        this.snack("Customer Created!", "success")
        this.closeCreateCustomer();
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.customerLoading = false;
      }
    },
    async deleteItem(){
      try {
        this.loader = true
        let res = await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.selectedRow.id}`)
        if(res.data.error) throw res.data.error
        this.snack(`${this.singular} Deleted 🎉`);
        await this.closeMenu();
        await this.getAllData();
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      } finally {
        this.loader = false;
      }
    },
  }
}
</script>
